var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.406,
    height: 21.866,
    viewBox: "0 0 39.406 21.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "view-icon",
    d: "M19.7,4.418a6.512,6.512,0,1,1-4.6,1.924,6.512,6.512,0,0,1,4.6-1.924ZM.338,10.029A34.219,34.219,0,0,1,3.647,6.541C8.255,2.347,13.494.105,18.919-.01s10.931,1.9,16.144,6.195a39.09,39.09,0,0,1,4.021,3.848,1.283,1.283,0,0,1,.08,1.6A25.613,25.613,0,0,1,34.233,16.9,22.294,22.294,0,0,1,20.34,21.852a24.369,24.369,0,0,1-14.192-4.6A28.649,28.649,0,0,1,.277,11.674a1.263,1.263,0,0,1,.061-1.645Zm5.012-1.6a31.872,31.872,0,0,0-2.434,2.466A25.927,25.927,0,0,0,7.6,15.179,21.887,21.887,0,0,0,20.33,19.325a19.781,19.781,0,0,0,12.316-4.4,22.714,22.714,0,0,0,3.848-3.944,35.416,35.416,0,0,0-3.046-2.841c-4.729-3.9-9.693-5.72-14.493-5.621S9.5,4.633,5.35,8.413Zm12.726-2.5a2.52,2.52,0,1,1-1.785.738,2.523,2.523,0,0,1,1.785-.738Z",
    transform: "translate(-0.002 0.015)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.4427cbbe930cdec75a7948d34648754a.svg";
export { ForwardRef as ReactComponent };